<template>
    <div alt="">
        <label :for="number" style="height: 0; flex-grow: 0" alt=""></label>
        <input :id="number" style="height: inherit; width: inherit; font-size: inherit;" ref="input" class="saved-input-narrator-friendly pageTextNormalBlindInput" v-on:change="handleInput()"/>
    </div>
</template>
<style scoped>
.saved-input-narrator-friendly{
    font-size: 36px;
    border:0;
    background: url(/pages/img/svgInputBackground2.svg), transparent;
    background-repeat: repeat-x;
    background-size: auto;
    background-clip: content-box, padding-box;
    background-position: 10% 93%;
    text-align:center;
    /* outline: 1px solid #F3DF00;*/
    padding-bottom: 10px;
    padding-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
    transition: 0.2s;
}
.saved-input-narrator-friendly:focus{
    /* outline: 3px solid #F3DF00; */
    outline: none;
    box-shadow: none;
}
.pageTextNormalBlindInput
{
    position:absolute;
    color:yellow;
    font-family: Open-Sans, sans-serif;
    z-index: 3;
    font-size: 40px;
    font-weight: bold;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: yellow;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: yellow;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: yellow;
}
</style>
<script>
    export default {
        props: ['number'],
        data () {
            return  {
                dbId: "undefined"
            }
        },
        methods: {
            handleInput(){
                this.$db.inputs.put({
                    id: this.dbId,
                    text: this.$refs.input.value
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });
            },
            async loadInput(){
                var value = await this.$db.inputs.get({
                    id: this.dbId,
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });
                if (value === undefined) return;
                console.log(value);
                this.$refs.input.value = value.text; 
            }
        },
        mounted() {
            if (this.$refs.input.disabled) {
                this.$refs.input.value = this.defaultText;
            }
            else
            {
                this.dbId = `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number}-savedInputNF-${this.number}`;
                this.loadInput();
            }
        }
    }
</script>
